document.addEventListener('DOMContentLoaded', function () {
  if (!window.mz) {
    return
  }
  function findAncestor(el, sel) {
    while (
      (el = el.parentElement) &&
      !(el.matches || el.matchesSelector).call(el, sel)
    );
    return el
  }
  function lazyLoadItem(el, item, callback) {
    let url = `/collections/all?sort_by=mezereon:${item.handle}`;
    if (mz.sectionId) {
      url = `/collections/all?section_id=${mz.sectionId}&sort_by=mezereon:${item.handle}`;
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const mzCardProduct = html.querySelector('.mz-card-product');
        callback(mzCardProduct.innerHTML);
        initImagesSize()
        lazyload()
        $('body').trigger('refreshCurrency')
        ttProductSmall()
        countDown(true)
        setTimeout(ttReinitflowProduct, 0)
        ttProductHover()
        wl_handler.init()
        compare.init()
        $('.mz-skeleton-wrapper').addClass('hidden')
      })
      .catch((e) => {
        console.log(e);
      });
  }
  function afterUpdate() {
    if (mz.track) {
      Array.from(document.querySelectorAll('.tt-btn-addtocart')).forEach(
        function (btn) {
          btn.addEventListener('click', function (e, btn) {
            var ctrl = findAncestor(e.target, '[data-mz-product-id]')
            if (!ctrl) {
              return
            }
            var uid = ctrl.getAttribute('data-mz-product-id')
            if (uid) {
              window.mz.track('add2cart', { uid: uid })
            }
          })
        }
      )
    }
    $('.mz-skeleton-wrapper').addClass('hidden')
  }
  function reloadSection(e) {
    if (e.detail.sectionId !== mz.sectionId) {
      return;
    }
    mz.initializeVueApp();
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
    mz.app.$bus.on('lazy-load-item', lazyLoadItem)
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (e) =>
        reloadSection(e)
      );
    }    
  }
})
